var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Leo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,9 C3.791,9 2,10.791 2,13 C2,15.209 3.791,17 6,17 C8.209,17 10,15.209 10,13 C10,10.791 8.209,9 6,9 M6,11 C7.103,11 8,11.897 8,13 C8,14.103 7.103,15 6,15 C4.897,15 4,14.103 4,13 C4,11.897 4.897,11 6,11",
    id: "Head",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,18 C20,19 19.103,20 18,20 C16.897,20 16,19.103 16,18 L16,8 C16,4.686 13.314,2 10,2 C6.686,2 4,4.686 4,8 C4,8.933 4.223,9.811 4.603,10.598 L6.295,9.47 C6.111,9.014 6,8.522 6,8 C6,5.794 7.794,4 10,4 C12.206,4 14,5.794 14,8 L14,18 C14,20.209 15.791,22 18,22 C20.209,22 22,20 22,18 L20,18 Z",
    id: "Mane",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeo);
export default __webpack_public_path__ + "static/media/leo.8eef58a4ec670a9b826e35331e03c733.svg";
export { ForwardRef as ReactComponent };